import React, { ReactNode } from 'react';
import { StyleSheet, Text, View, Pressable, StyleProp, ViewStyle } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { GAME_OPERATION_TYPE } from '../../constants/constants';

interface IGameOperationTypeButtonProps {
  operation: GAME_OPERATION_TYPE;
  onPress: (gameOperation: GAME_OPERATION_TYPE) => void;
  additionalIcon?: ReactNode;
  textBackground?: string;
  containerStyle?: StyleProp<ViewStyle>;
}

const GameOperationTypeButton = (props: IGameOperationTypeButtonProps) => {
  const { onPress, additionalIcon, textBackground, operation } = props;

  return (
    <View style={props.containerStyle}>
      <LinearGradient
        colors={['#FFCF53', '#FF9900']}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={styles.gradientBorder}
      >
        <Pressable onPress={() => onPress(operation)} style={[styles.btnContainer]}>
          <View style={styles.textContainer}>
            <Text
              maxFontSizeMultiplier={1}
              style={[styles.text, { backgroundColor: textBackground || 'transparent' }]}
            >
              {operation}
            </Text>
            <View pointerEvents="none" style={styles.additionalIcon}>
              {additionalIcon}
            </View>
          </View>
        </Pressable>
      </LinearGradient>
    </View>
  );
};

export { GameOperationTypeButton };

const styles = StyleSheet.create({
  gradientBorder: {
    borderRadius: 16,
    paddingRight: 7,
    paddingTop: 2,
    height: 78,
    width: 300,
  },

  btnContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    height: 74,
    width: 294,
    justifyContent: 'center',
    marginLeft: 8,
    borderRadius: 16,
    backgroundColor: '#FEDD88',
  },
  text: {
    fontFamily: 'Secular One',
    fontSize: 20,
    fontWeight: '400',
    color: '#121212',
    paddingVertical: 3,
    paddingHorizontal: 12,
  },
  additionalIcon: {
    position: 'absolute',
    right: 10,
  },
});
